import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from "react-toastify";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import LandingPage from "./components/registration/components/LandingPage.jsx";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./components/registration/components/authConfig.js";
import { MsalProvider } from "@azure/msal-react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import UserDashboard from "./components/registration/components/UserDashboard.jsx";
import CreateAccountWithEmail from "./components/registration/components/CreateAccountWithEmail.jsx";
import AdminDashboard from "./components/global-admin-dashboard/components/AdminDashboard.jsx";
import SubAdminDashboard from "./components/sub-admin-dashboard/components/SubAdminDashboard.jsx";
import PageOutlet from "./components/common/navigation-bars/PageOutlet.jsx";
import DocumentsHistory from "./components/sub-admin-dashboard/components/DocumentsHistory.jsx";
import FinancialAnalysis from "./components/pitch-documents/components/steps/FinancialAnalysis.jsx";
import DataRoom from "./components/sub-admin-dashboard/due-diligence/pages/DataRoom.jsx";
import DDSelection from "./components/sub-admin-dashboard/due-diligence/pages/DDSelection.jsx";
import DueDiligence from "./components/sub-admin-dashboard/due-diligence/components/DueDiligence.jsx";
import AddNewCompany from "./components/sub-admin-dashboard/due-diligence/components/AddNewCompany.jsx";
import DDQDashboard from "./components/sub-admin-dashboard/due-diligence/pages/DDQDashboard.jsx";
import OnboardingPage from "./components/newspringcapital/components/onboarding/OnboardingPage.jsx";
import NewSpringDashboard from "./components/newspringcapital/components/dashboard/NewSpringDashboard.jsx";

const theme = createTheme({
  typography: {
    fontFamily: `'Bio Sans', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
  },
  palette: {
    background: {
      default: "#EAF0F7", // light gray background
    },
  },
});

export const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance.initialize();

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          style={{
            minHeight: "100vh",
            background: theme.palette.background.default,
          }}
        >
          <BrowserRouter>
            <AuthenticatedTemplate>
              <Routes>
                <Route path="/UserDashboard" element={<UserDashboard />} />
                <Route
                  path="/global-admin-dashboard"
                  element={<AdminDashboard />}
                />
                <Route path="*" element={<LandingPage />} />
                 <Route path="/new-spring-capital" element={<OnboardingPage />} />
                 <Route path="/new-spring-dashboard" element={<NewSpringDashboard />} />
                <Route element={<PageOutlet />}>
                  <Route path="/dashboard" element={<SubAdminDashboard />} />
                  <Route
                    path="/documents-history"
                    element={<DocumentsHistory />}
                  />
                  <Route path="/analysis-report" element={<FinancialAnalysis />} />
                  <Route path="/due-diligence" element={<DueDiligence />} />
                   <Route path="/due-diligence/add-company" element={<AddNewCompany />} />
                  <Route path="/due-diligence/data-room/:companyId" element={<DataRoom />} />
                  <Route
                    path="/due-diligence/dd-selection"
                    element={<DDSelection />}
                  />
                  <Route
                    path="/due-diligence/analysis-report"
                    element={<FinancialAnalysis />}
                  />
                  <Route path="/due-diligence/ddq-dashboard" element={<DDQDashboard />} />
                </Route>
              </Routes>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route
                  path="/create-an-account"
                  element={<CreateAccountWithEmail />}
                />
              </Routes>
            </UnauthenticatedTemplate>
          </BrowserRouter>
          <ToastContainer />
        </div>
      </ThemeProvider>
    </MsalProvider>
  );
};

export default App;
